import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useTaskStore } from "../../store/task.store";
import { isRouteAllowed } from "../../data/taskNavigation";

interface TaskGuardProps {
  children?: React.ReactNode;
}

/**
 * Route guard that checks if the current path is allowed
 * based on the user's selected tasks. Redirects to /dashboard if not.
 *
 * Can be used as a wrapper around children, or as a layout route element
 * (without children, renders <Outlet> for nested routes).
 */
export function TaskGuard({ children }: TaskGuardProps) {
  const location = useLocation();
  const { selectedTasks } = useTaskStore();
  const selectedSlugs = selectedTasks.map((t) => t.slug);

  if (!isRouteAllowed(location.pathname, selectedSlugs)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children ?? <Outlet />}</>;
}
